<div class="ui-detail-row">
  <span class="ui-detail-row-label">{{ label() }}</span>
  <span class="ui-detail-row-value">
    @if (hasValue()) {
      {{ value() }}
    } @else {
      <ng-content />
    }
  </span>
</div>
